import * as React from 'react';
import { useIntl } from 'react-intl';

import { useTitleStore } from 'src/stores/useTitleStore';
import { billingRunsMessages } from 'src/features/billingRuns/utils/messages';
import BillingRunsTable from 'src/features/billingRuns/components/tables/BillingRunsTable';

const BillingRunsLayout = () => {
    const { formatMessage } = useIntl();

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(billingRunsMessages.billingRuns));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <BillingRunsTable />;
};

export default BillingRunsLayout;
